import { render } from "./TicketsGameInputsModal.vue?vue&type=template&id=a20c1408&ts=true&lang=pug"
import script from "./TicketsGameInputsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TicketsGameInputsModal.vue?vue&type=script&lang=ts&setup=true"

import "./TicketsGameInputsModal.vue?vue&type=style&index=0&id=a20c1408&lang=scss"

import exportComponent from "/home/runner/work/affolterNET.Tickets/affolterNET.Tickets/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__